import { render } from "./Wishlist.vue?vue&type=template&id=50e6e9a2&scoped=true"
import script from "./Wishlist.vue?vue&type=script&lang=ts"
export * from "./Wishlist.vue?vue&type=script&lang=ts"

import "./Wishlist.vue?vue&type=style&index=0&id=50e6e9a2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-50e6e9a2"

export default script